/**
 * Function that validates whether a file is of image mimetype image/*
 * @param file - File to check the type of
 * @returns boolean value representing the result of mimetype check
 */
export function fileIsImage(file: File) {
  return /image\/.+/.test(file.type)
}
